import InfoMessage from './InfoMessage';

export default InfoMessage;
